import React from 'react';
import { PhoneOffIcon } from 'lucide-react';
interface EmptyStateProps {
  title?: string;
  description?: string;
}
export function EmptyState({
  title = 'No users match your filters',
  description = 'Try a different name, extension, or team.'
}: EmptyStateProps) {
  return <div className="flex flex-col items-center justify-center rounded-2xl border border-line bg-surface px-6 py-16 text-center shadow-card" data-id="element-105" data-mp="3n2cy56cymltd">
      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-canvas" data-id="element-106" data-mp="3j1axqm7b43pt">
        <PhoneOffIcon className="h-5 w-5 text-subtle" aria-hidden data-id="element-107" data-mp="3e9100jzy9zcz" />
      </span>
      <p className="mt-3 text-sm font-semibold text-ink" data-id="element-108" data-mp="399wsdxsoc9or">{title}</p>
      <p className="mt-1 text-sm text-muted" data-id="element-109" data-mp="34bmw1jv7r31k">{description}</p>
    </div>;
}